import {
  EvaluableType,
  SampleError,
} from "@/services/backend/sample-error/sample-error";
import { Badge } from "@/shared/components/ui/badge";
import { ReactElement } from "react";

interface ErrorBadgeProps {
  sampleError: SampleError;
}

export default function ErrorBadge({
  sampleError,
}: ErrorBadgeProps): ReactElement {
  if (sampleError.evaluableType === EvaluableType.Evaluable) {
    return (
      <Badge className="bg-green-600 text-white">
        {sampleError.description}
      </Badge>
    );
  }

  return (
    <Badge className="bg-red-600 text-white">{sampleError.description}</Badge>
  );
}
